(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('shift', {
        templateUrl: 'views/components/views/shift/shift.template.html?v=' + module.version,
        controllerAs: 'vm',
        bindings: {
            shiftId: '<?',
            onSave: '&',
            onDelete: '&'
        },
        controller: ['$stateParams', '$q', 'stateService', 'utilityService', 'modalService', 'translateService', 'shiftService', 'skillsCertificateTypeService', 'layoutService', function ($stateParams, $q, stateService, utilityService, modalService, translateService, shiftService, skillsCertificateTypeService, layoutService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let shiftId = vm?.shiftId ?? $stateParams.shift_id;
            let tabletSize = layoutService.getMediaQueries().tablet;

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
            	edit: {},
            	selectListColours: [],
                itemsListWeekDays: [],
                lockedSave: false,
                lockedDelete: false
            };

            // #endregion VARIABLES & DEFINITIONS
            
            // #region TRANSLATE SERVICE

            translateService.translateBatch(translations).then(function (data) {
                angular.forEach(translations, function (_, key) {
                    if (angular.isDefined(data[key])) {
                        translations[key] = data[key];
                    }
                });
            });

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE CALLS

            let loadEdit = function () {
                const deferred = $q.defer();

                shiftService.getEdit({ shift_id: shiftId }).then(function (info) {
                    angular.copy(info[0], vm.model.edit);

                    $q.all([
                        loadWeekDays()
                    ]).then(() => deferred.resolve());
                });

                return deferred.promise;
            };

            let loadHexColors = function () {
                skillsCertificateTypeService.listHexColors().then(function (list) {
                    angular.copy(list, vm.model.selectListColours);
                });
            };
    
            let loadWeekDays = function () {
                if (utilityService.validateParmsValue(vm.model.edit.shift_id) !== true) return;

                vm.model.itemsListWeekDays = [];

                return shiftService.listWeekDays({ shift_id: vm.model.edit.shift_id }).then(function (list) {
                    angular.copy(list, vm.model.itemsListWeekDays);
                });
            };

            // #endregion LOAD PROCEDURE CALLS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                shiftService.saveObj(vm.model.edit).then(function (response) {
                    if (response[0].status_no !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                            message: response[0].status_message,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;

                        if (angular.isFunction(vm.onSave) && tabletSize.matches === true) {
                            vm.onSave();
                            loadEdit();
                            loadHexColors();
                        } else {
                            stateService.back();
                        }
                    }
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.deleteValues = function () {
                vm.model.lockedDelete = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(function () {
                    shiftService.deleteItem({ shift_id: vm.model.edit.shift_id }).then(function (response) {
                        if (response[0].status_no !== '0') {
                        	modalService.show({
                        		type: 'warning',
                        		title: translations.error,
                                message: response[0].status_message,
                        		buttons: [{
                        			label: translations.ok,
                        			cssClass: 'btn-warning',
                        			action: function (dialogItself) {
                        				dialogItself.close();
                        				vm.model.lockedDelete = false;
                        			}
                        		}]
                        	});
                        } else {
                        	vm.model.lockedDelete = false;

                            if (angular.isFunction(vm.onDelete) && tabletSize.matches === true) {
                                vm.shiftId = '0';
                                vm.onDelete();
                                loadEdit();
                                loadHexColors();
                            } else {
                                stateService.back();
                            }
                        }
                    }, function () {
                        vm.model.lockedDelete = false;
                    });
                }, function () {
                    vm.model.lockedDelete = false;
                });
            };

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                //loadEdit();
                //loadHexColors();
            };

            // #endregion ON INIT FUNCTION

            // #region ON CHANGES FUNCTION

            vm.$onChanges = function (changes) {
                if (changes?.shiftId?.currentValue) shiftId = changes.shiftId.currentValue;

                if (shiftId) {
                    loadEdit();
                    loadHexColors();
                }
            };

            // #endregion ON CHANGES FUNCTION

        }]
    });
})();
